import {DashboardType} from "../../../model/dashboard/types";
import {DashboardConfig} from "../../../model/dashboard/dashboard-config";
import {WidgetConfig} from "../../../model/widget/widget-config";
import {ConditionsLogicalOperator} from "../../../../../model2/conditions/collection";
import {WidgetType} from "../../../model/widget/widget-type";
import {TasksStatus} from "../../../widgets/constants/task-status";

export function projectProgressConfig() {

    const widgets : WidgetConfig[] = [
        {
            "cardLayout": undefined,
            "settings": {
                "counterType": "time-reports",
                "label": "Hours"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "date-relative-range",
                        "id": "cond1",
                        "value": {
                            "start": -7,
                            "end": 0
                        },
                        "systemFieldId": "timeReport.date"
                    }
                ],
                "logicalOperator": ConditionsLogicalOperator.AND
            },
            "title": "Time reported this week",
            "gridPosition": {
                "y": 2,
                "h": 1,
                "w": 4,
                "x": 0
            },
            "type": WidgetType.COUNTER,
            "id": "yl0v"
        },
        {
            "cardLayout": undefined,
            "settings": {
                "reportDate": {
                    "lastDays": 90
                },
                "projectIds": [
                    "U3PB5q",
                    "KQiV0y",
                    "gUqmWp",
                    "gV8mQo",
                    "Fxk5pA"
                ],
                "tasksStatus": TasksStatus.CLOSED,
                "counterType": "tasks-total"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    // {
                    //     "type": "includes",
                    //     "id": "5oq6",
                    //     "value": [
                    //         "dGO5Az",
                    //         "4mITwh",
                    //         "zmRAeY",
                    //         "xaaa0P"
                    //     ],
                    //     "systemFieldId": "task.statusId"
                    // }
                ],
                "logicalOperator": ConditionsLogicalOperator.AND
            },
            "title": "Total completed",
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 12,
                "x": 0
            },
            "type": WidgetType.LINE_CHART,
            "id": "25ow"
        },
        {
            "cardLayout": undefined,
            "settings": {
                "counterType": "tasks-estimates",
                "label": "Hours"
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "cond1",
                        "value": [
                            1,
                            2,
                            3,
                            4
                        ],
                        "systemFieldId": "task.systemStatus"
                    }
                ],
                "logicalOperator": ConditionsLogicalOperator.AND
            },
            "title": "Total estimated open tasks",
            "gridPosition": {
                "y": 3,
                "h": 1,
                "w": 4,
                "x": 0
            },
            "type": WidgetType.COUNTER,
            "id": "1ued"
        },
        {
            "cardLayout": undefined,
            "settings": {
                "includeSubFolders": true,
                "userIds": [],
                "type": "timesheet",
                "groupBy": "userId",
                "daterange": {
                    "start": -30,
                    "end": 0
                }
            },
            "color": 6,
            // "conditions": null,
            "title": "Time sheets",
            "gridPosition": {
                "y": 4,
                "h": 3,
                "w": 12,
                "x": 0
            },
            "type": WidgetType.TIME_REPORT,
            "id": "6my0"
        },
        {
            "cardLayout": undefined,
            "settings": {
                "includeSubFolders": true,
                "showClosedTasks": true,
                "displayPropertyFieldId": "createdByUserId",
                "includeSubtasks": true
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "date-relative-range",
                        "id": "qqc9",
                        "value": {
                            "start": -7,
                            "end": 0
                        },
                        "systemFieldId": "task.momentCreated"
                    }
                ],
                "logicalOperator": ConditionsLogicalOperator.AND
            },
            "title": "Tasks created this week",
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 4
            },
            "type": WidgetType.TASK_LIST,
            "id": "0ixc"
        },
        {
            "cardLayout": undefined,
            "settings": {
                "includeSubFolders": true,
                "showClosedTasks": true,
                "displayPropertyFieldId": "assignedToUserId",
                "includeSubtasks": true
            },
            "color": 6,
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "cond1",
                        "value": [
                            5
                        ],
                        "systemFieldId": "task.systemStatus"
                    },
                    {
                        "type": "date-relative-range",
                        "id": "cond1",
                        "value": {
                            "start": -7,
                            "end": 0
                        },
                        "systemFieldId": "task.momentClosed"
                    }
                ],
                "logicalOperator": ConditionsLogicalOperator.AND
            },
            "title": "Tasks completed this week",
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 8
            },
            "type": WidgetType.TASK_LIST,
            "id": "vq8r"
        }
    ]

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.PROJECT,
        "widgets"   : widgets
    }

    // dashboardConfig.widgets = dashboardConfig.widgets.concat(createWidgets(userId, widgetIds) as any[])

    return dashboardConfig
}


